import PageTitle from '../components/PageTitle';

import Section from '../components/Section';
import { InlineClippedImage } from '../components/InlineClippedImage';

import Connell_2005_Sunset from '../assets/images/content/Connell_2005_Sunset.jpg';
import forward from '../assets/images/forward.svg';
import move from '../assets/images/move.svg';

import Q3FinancialHighlightsAnnual from '../components/content/tables/FinancialHighlights-q3';
const FinancialHighlights = () => {
	return (
		<>
			<PageTitle title="Financial Highlights" />
			<div className="w-full max-w-[100vw]">
				<div className="container py-6 max-w-container-lg">
					<Q3FinancialHighlightsAnnual />
				</div>
			</div>

			<Section backgroundColor="#767727" textColor="#fff" className="py-12 md:py-24">
				<div className="container">
					<img src={move} className="ml-auto opacity-20 hover:opacity-100 max-w-[739px] duration-300" alt="" />
				</div>
				<div className="container my-12 max-w-container-md">
					<div>
						<InlineClippedImage
							src={Connell_2005_Sunset}
							alt=""
							dimensions={{
								width: 1728,
								height: 1296,
							}}
							clipPaths={[
								{
									initial: {
										x: '52%',
										y: '14%',
										width: '40%',
									},
									expanded: {
										x: '0%',
										y: '0%',
										width: '100%',
									},
								},
							]}
						/>
					</div>
				</div>
				<div className="container">
					<img src={forward} className="opacity-20 hover:opacity-100 duration-300 max-w-[739px]" alt="" />
				</div>
			</Section>
		</>
	);
};

export default FinancialHighlights;
